import { RootState } from '@/store/store'
import { useSelector } from 'react-redux'

export const useRole = () => {
  const { roles } = useSelector((state: RootState) => state.user)

  const hasAccess = (requiredRoles: string[] | string): boolean => {
    const userRoleSet = new Set(roles)
    return (Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles]).every((role) => userRoleSet.has(role))
  }

  const hasAnyAccess = (requiredRoles: string[] | string): boolean => {
    const userRoleSet = new Set(roles)
    return (Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles]).some((role) => userRoleSet.has(role))
  }

  return { hasAccess, hasAnyAccess }
}
